export enum ActiveType {
    procaar,
    equipoCarga,
    tractoCamiones,
    montacargasPatineshidraulicos,
    retroexcavadora,
    equipoComputo,
    racksIndustriales,
    cocinasIndustriales,
    mobiliarioYEquipo,
    equipoMedicoEstandar,
    maquinariaEstandarYEquipoEspecializado
}

export enum CurrentsSteps {
    FirstStep,
    FirstStepLeasing,
    FormOption,
    Ekatena,
    ThirdStep,
    ManualForm,
    FourthStep,
    FifthStep,
    SixStep,
    AceptView,
    FinalStep
}

export enum StepController {
    StepOne,
    StepTwo,
    StepTree,
    StepFour,
    StepFive,
    StepSix,
}